@if (data()) {
  <div class="p-3 md:p-5 flex flex-column">
    <!-- <app-button
      [btnSeverity]="ButtonSeverity.TERTIARY"
      [btnSize]="ButtonSize.MD"
      (btnClicked)="routeToPackagePackages()"
      class="w-7rem back-button"
    >
      <app-arrow stroke="#7E838F" direction="left"></app-arrow>
      <div class="text-sm-semibold text-gray-900 white-space-nowrap">Svi paketi</div>
    </app-button> -->

      <button
      type="button"
      class="back-link tap-target inline-flex align-items-center cursor-pointer"
      (click)="routeToPackagePackages()"
    >
      <app-arrow stroke="#7E838F" direction="left" width="12" height="12" class="mr-2 flex"></app-arrow>
      <div class="label text-sm-semibold text-gray-900">Zahtevi za kupovinu</div>
    </button>


    <div class="flex flex-column lg:flex-row w-full">
      <!--Left(details)-->
      <div class="flex flex-1 flex-column details-col">
        <div class="flex flex-column align-items-start gap-3 sm:flex-row sm:align-items-center sm:gap-0">
          <div class="icon">
            @if (data()?.userData?.isCompany) {
              <app-building-05 stroke="#414651" width="26" height="26"></app-building-05>
            } @else {
              <app-user-circle stroke="#414651" width="26" height="26"></app-user-circle>
            }
          </div>
          <div class="sm:ml-3 flex flex-column identity-col">
            <div class="flex flex-wrap align-items-center gap-2-5 name-row">
              <div class="display-xs-semibold text-gray-900">{{ data()?.userData?.name }}</div>
              <div>
                @if (data()?.userData?.isCompany) {
                  <p-chip label="Pravno lice" class="white md"></p-chip>
                } @else {
                  <p-chip label="Fizičko lice" class="white md"></p-chip>
                }
              </div>
            </div>
            <div class="mt-2 flex flex-wrap align-items-center contact-row">
              <div class="flex align-items-center gap-2 min-w-0">
                <app-mail-02 class="flex-shrink-0" stroke="#ADB0B8" width="16" height="13"></app-mail-02>
                <span class="text-sm-regular text-gray-600">{{ data()?.userData?.email }}</span>
              </div>
              <div class="flex align-items-center gap-2">
                <app-phone class="flex-shrink-0" stroke="#ADB0B8" width="16" height="16"></app-phone>
                <span class="text-sm-regular text-gray-600">{{ data()?.userData?.phone }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <!-- Header -->
          <div class="header flex flex-column">
            <div class="flex justify-content-between align-items-center">
              <div class="text-lg-semibold text-gray-900">Detalji zahteva</div>
              <p-chip
                [label]="data()!.status!.description"
                [class]="getStatusChipClass(data()!.status!.value!)"
              >
              </p-chip>
            </div>
            <div class="mt-1 text-sm-regular text-gray-600">Informacije i status zahteva za kupovinu paketa</div>
          </div>

          <!-- Content -->
          <div class="content flex flex-column gap-4">

            <!-- Package info row -->
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center">
                <div class="package-icon">
                  <app-cube-01 stroke="#414651" width="16" height="16"></app-cube-01>
                </div>
                <div class="ml-2-5 flex flex-column">
                  <span class="text-xs-semibold text-gray-500">PAKET</span>
                  <div class="text-sm-medium text-gray-900">{{ data()!.name! }}</div>
                </div>
              </div>
              <div class="flex flex-column">
                <span class="text-xs-semibold text-gray-500 text-right">DATUM ZAHTEVA</span>
                <div class="text-sm-medium text-gray-900">{{ getDateFormatedWithTime(data()!.createdOn!) }}</div>
              </div>
            </div>

            <!-- Stepper -->
            <div class="stepper flex">

              <!-- Step 1: Kreiran zahtev -->
              <div class="flex flex-column align-items-center text-center">
                @if (data()!.status!.value! >= 0 && data()!.status!.value! !== UserPackageStatus.CANCELLED) {
                  <app-step-success width="1.5rem" height="1.5rem"></app-step-success>
                  <div class="mt-2-5 text-sm-semibold text-gray-700">Kreiran zahtev</div>
                  <div class="mt-1 text-sm-regular text-gray-600">{{ getDateFormattedShort(data()!.createdOn!) }}</div>
                } @else {
                  <p-badge value="1" severity="secondary" [dt]="badgeStyle"></p-badge>
                  <div class="mt-2-5 text-sm-semibold text-gray-400">Kreiran zahtev</div>
                }
              </div>

              <div class="stepper-line"></div>


              <!-- Step 2: Faktura poslata -->
              <div class="flex flex-column align-items-center text-center">
                @if (data()!.status!.value! >= 1 && data()!.status!.value! !== UserPackageStatus.CANCELLED) {
                  <app-step-success width="1.5rem" height="1.5rem"></app-step-success>
                  <div class="mt-2-5 text-sm-semibold text-gray-700">Faktura poslata</div>
                  <div
                    class="mt-1 text-sm-regular text-gray-600">{{ getDateFormattedShort(data()!.invoiceSentDateTime!) }}
                  </div>
                } @else {
                  <p-badge value="2" severity="secondary" [dt]="badgeStyle"></p-badge>
                  <div class="mt-2-5 text-sm-semibold text-gray-400">Faktura poslata</div>
                }
              </div>

              <div class="stepper-line"></div>

              <!-- Step 3: Potvrđena uplata -->
              <div class="flex flex-column align-items-center text-center">
                @if (data()!.status!.value! >= 2 && data()!.status!.value! !== UserPackageStatus.CANCELLED) {
                  <app-step-success width="1.5rem" height="1.5rem"></app-step-success>
                  <div class="mt-2-5 text-sm-semibold text-gray-700">Potvrđena uplata</div>
                  <div
                    class="mt-1 text-sm-regular text-gray-600">{{ getDateFormattedShort(data()!.invoiceSentDateTime!) }}
                  </div>
                } @else {
                  <p-badge value="3" severity="secondary" [dt]="badgeStyle"></p-badge>
                  <div class="mt-2-5 text-sm-semibold text-gray-400">Potvrđena uplata</div>
                }
              </div>

            </div>

          </div>

        </div>
        <div class="card">
          <!-- Header -->
          <div class="header flex flex-column">
            <div class="text-lg-semibold text-gray-900">Informacije klijenta</div>
            <div class="mt-1 text-sm-regular text-gray-600">Informacije o klijentu potrebne za popunjavanje fakture
            </div>
          </div>
          <!-- Content -->
          <div class="content flex flex-column gap-4">
            <div class="info-grid">
              <!--Name and surname / company name-->
              <div class="flex align-items-center">
                @if (data()!.userData!.isCompany) {
                  <app-building-05 stroke="#ADB0B8" width="16" height="16"></app-building-05>
                } @else {
                  <app-user-circle stroke="#ADB0B8" width="16" height="16"></app-user-circle>
                }
                <div class="ml-2-5 flex flex-column">
                  <span class="text-xs-semibold text-gray-500">{{ data()!.userData!.isCompany ? 'NAZIV KOMPANIJE' : 'IME I PREZIME' }}</span>
                  <div class="mt-1 text-sm-medium text-gray-900">{{ data()!.userData!.name }}</div>
                </div>
              </div>
              @if (data()!.userData!.isCompany) {
                <!--PIB-->
                <div class="flex align-items-center">
                  <app-hash-02 stroke="#ADB0B8" width="16" height="16"></app-hash-02>
                  <div class="ml-2-5 flex flex-column">
                    <span class="text-xs-semibold text-gray-500">PIB</span>
                    <div class="mt-1 text-sm-medium text-gray-900">{{ data()!.userData!.pib || '-' }}</div>
                  </div>
                </div>
                <!--Registration number-->
                <div class="flex align-items-center">
                  <app-hash-02 stroke="#ADB0B8" width="16" height="16"></app-hash-02>
                  <div class="ml-2-5 flex flex-column">
                    <span class="text-xs-semibold text-gray-500">MATIČNI BROJ</span>
                    <div class="mt-1 text-sm-medium text-gray-900">{{ data()!.userData!.mb || '-' }}</div>
                  </div>
                </div>
              }
              <!--Address-->
              <div class="flex align-items-center">
                <app-home-line stroke="#ADB0B8" width="16" height="16"></app-home-line>
                <div class="ml-2-5 flex flex-column">
                  <span class="text-xs-semibold text-gray-500">{{ data()!.userData!.isCompany ? 'ADRESA SEDIŠTA' : 'ADRESA' }}</span>
                  <div class="mt-1 text-sm-medium text-gray-900">{{ data()!.userData!.address }}</div>
                </div>
              </div>
              <!--City-->
              <div class="flex align-items-center">
                <app-marker-pin-01 stroke="#ADB0B8" width="13" height="16"></app-marker-pin-01>
                <div class="ml-2-5 flex flex-column">
                  <span class="text-xs-semibold text-gray-500">GRAD</span>
                  <div class="mt-1 text-sm-medium text-gray-900">{{ data()!.userData!.city }}</div>
                </div>
              </div>
              <!--Postal code-->
              <div class="flex align-items-center">
                <app-map-01 stroke="#ADB0B8" width="16" height="16"></app-map-01>
                <div class="ml-2-5 flex flex-column">
                  <span class="text-xs-semibold text-gray-500">POŠTANSKI BROJ</span>
                  <div class="mt-1 text-sm-medium text-gray-900">{{ data()!.userData!.postalCode }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--Right(actions)-->
      @if (hasActions()) {
      <div class="mt-4 lg:mt-0 lg:ml-5 w-full lg:w-15rem flex flex-column">
          <div class="text-lg-semibold text-gray-900">Akcije</div>

          @switch (data()!.status!.value) {
            @case (UserPackageStatus.NEW) {
              <app-button
                class="mt-4"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                (btnClicked)="openInvoiceDialog()"
              >
                <app-send-01 stroke="white"></app-send-01>
                <div class="text-sm-semibold text-white">Pošalji fakturu</div>
              </app-button>
              <app-button
                class="mt-3-5"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-check-circle stroke="#ADB0B8"></app-check-circle>
                <div class="text-sm-semibold text-gray-400">Potvrdi uplatu</div>
              </app-button>
            }
            @case (UserPackageStatus.INVOICE_SENT) {
              <app-button
                class="mt-4"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-check stroke="#ADB0B8"></app-check>
                <div class="text-sm-semibold text-gray-400">Faktura poslata</div>
              </app-button>
              <app-button
                class="mt-3-5"
                [btnSeverity]="ButtonSeverity.SUCCESS"
                [btnSize]="ButtonSize.SM"
                (btnClicked)="showConfirmPaymentDialog.set(true)"
              >
                <app-check-circle stroke="white"></app-check-circle>
                <div class="text-sm-semibold text-white">Potvrdi uplatu</div>
              </app-button>
            }
            @case (UserPackageStatus.ACTIVE) {
              <app-button
                class="mt-4"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-check stroke="#ADB0B8"></app-check>
                <div class="text-sm-semibold text-gray-400">Faktura poslata</div>
              </app-button>
              <app-button
                class="mt-3-5"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-check stroke="#ADB0B8"></app-check>
                <div class="text-sm-semibold text-gray-400">Uplata potvrđena</div>
              </app-button>
            }
            @case (UserPackageStatus.CANCELLED) {
              <app-button
                class="mt-4"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-send-01 stroke="#ADB0B8"></app-send-01>
                <div class="text-sm-semibold text-gray-400">Pošalji fakturu</div>
              </app-button>
              <app-button
                class="mt-3-5"
                [btnSeverity]="ButtonSeverity.PRIMARY"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-check-circle stroke="#ADB0B8"></app-check-circle>
                <div class="text-sm-semibold text-gray-400">Potvrdi uplatu</div>
              </app-button>
              <app-button
                class="mt-3-5"
                [btnSeverity]="ButtonSeverity.OUTLINE"
                [btnSize]="ButtonSize.SM"
                [isBtnDisabled]="true"
              >
                <app-slash-circle-01 stroke="#ADB0B8"></app-slash-circle-01>
                <div class="text-sm-semibold text-gray-400">Odbij zahtev</div>
              </app-button>
            }
          }
          <!-- Shared across NEW and INVOICE_SENT -->
          @if (data()!.status!.value === UserPackageStatus.NEW || data()!.status!.value === UserPackageStatus.INVOICE_SENT) {
            <app-button
              class="mt-3-5"
              [btnSeverity]="ButtonSeverity.OUTLINE"
              [btnSize]="ButtonSize.SM"
              (btnClicked)="showCancelDialog.set(true)"
            >
              <app-slash-circle-01 stroke="#181D27"></app-slash-circle-01>
              <div class="text-sm-semibold text-gray-900">Odbij zahtev</div>
            </app-button>
          }

        </div>
      }
    </div>
  </div>
}

@if (selectedCommand()) {
  <app-invoice-sent-dialog
    [(isVisible)]="showInvoiceDialog"
    [command]="selectedCommand()!"
    (submitted)="setInvoiceSent($event)" />
}

<app-confirm-payment-dialog
  [(isVisible)]="showConfirmPaymentDialog"
  (confirmed)="setAsPaid()"
  (cancelled)="showConfirmPaymentDialog.set(false)"
></app-confirm-payment-dialog>

<app-confirm-action-dialog
  [(isVisible)]="showCancelDialog"
  title="Odbijte zahtev"
  message="Da li ste sigurni da želite da odbijete zahtev za kupovinu paketa? Klijent će morati da pošalje novi zahtev."
  confirmLabel="Odbij zahtev"
  (confirmed)="confirmCancel()"
  (cancelled)="showCancelDialog.set(false)"
></app-confirm-action-dialog>
